import { useContext, useEffect, useState } from 'react';
import { ContextState } from '..';
import {
    links,
    SubLinks,
    preCollegeLinks,
    launchpadLinks,
    skillUpLinks,
    certificates,
    dlPprogram
} from '../../siteData/header';
import Cookies from 'js-cookie';
import up_arrow from '../../assets/images/up_arrow.svg';
import down_arrow from '../../assets/images/down_arrow.svg';

const Sidebar = ({ history }) => {
    const { contextReducer } = useContext(ContextState);
    const sidebar_links = links;
    const sub_Links = SubLinks;
    const role = Cookies.get('cms_role');

    const [subMenu, setSubmenu] = useState(false);

    useEffect(()=>{
        setSubmenu(false)
    },[contextReducer])

    useEffect(() => {
        if (subMenu) {
          const sksReportsElement = document.querySelector(".sks_reports");
          if (sksReportsElement) {
            sksReportsElement.scrollTop =
              sksReportsElement.scrollHeight - sksReportsElement.clientHeight;
          }
        }
      }, [subMenu]);
      
    const handleClickReport = (link, check) => {
        if (check) {
            setSubmenu(!subMenu);
        } else {
            history.push(link.route);
            setSubmenu(true);
        }
    };

    const cmsLinks = (cmsType) => {
        switch (cmsType) {
            case 'career-launch':
                return launchpadLinks;
            case 'pre-college':
                return preCollegeLinks;
            case 'certificates':{
                return certificates;
            }
            case 'dl-program' :{
                return dlPprogram
            }
            default:
                return skillUpLinks;
        }
    };
    
    
    return (
        <div className='sidebar sks_reports'>
            {cmsLinks(contextReducer.cms_type).map((link) => {
                if (
                    contextReducer.cms_type === 'skill-up' &&
                    link?.children.length > 0
                ) {
                    let check =
                        link?.children?.filter(
                            (list) => list?.route === window?.location?.pathname
                        ).length > 0;
                    return (
                        <>
                            <ul className='list_unstyled'>
                                <li
                                    onClick={() => handleClickReport(link, check)}
                                    className={
                                        check &&
                                        'active d_flex align_items_center justify_content_between'
                                    }
                                >
                                    <span className='d_block fullWidth '>
                                        {link.name}
                                        <span className='d_block fullWidth justify_content_end'>
                                            <img
                                                src={subMenu ? up_arrow : down_arrow}
                                                alt='Group icon'
                                                height='12'
                                            />
                                        </span>
                                    </span>
                                </li>
                            </ul>
                            {check &&
                                subMenu &&
                                link?.children?.map((item, i) => {
                                    return (
                                        <ul className='list_unstyled'>
                                           <li
                                                onClick={() => history.push(item.route)}
                                                className={`pl_5 ${item.route === history.location.pathname
                                                    ? 'active'
                                                    : ''
                                                    }`}
                                            >
                                                <span>{item.name}</span>
                                            </li>
                                        </ul>
                                    );
                                })}
                        </>
                    );
                }
                if (
                    // ( contextReducer.cms_type === 'pre-college' || contextReducer.cms_type === 'certificates') 
                    ( contextReducer.cms_type === 'pre-college' || contextReducer.cms_type === 'certificates' || contextReducer.cms_type === 'dl-program' )  &&
                    link?.children.length > 0
                ) {
                    let check =
                        link?.children?.filter(
                            (list) => list?.route === window?.location?.pathname
                        ).length > 0;
                    return (
                        <>
                            <ul className='list_unstyled'>
                                <li
                                    onClick={() => handleClickReport(link, check)}
                                    className={
                                        check &&
                                        'active d_flex align_items_center justify_content_between'
                                    }
                                >
                                    <span className='d_block fullWidth '>
                                        {link.name}
                                        <span className='d_block fullWidth justify_content_end'>
                                            <img
                                                src={subMenu ? up_arrow : down_arrow}
                                                alt='Group icon'
                                                height='12'
                                            />
                                        </span>
                                    </span>
                                </li>
                            </ul>
                            {check &&
                                subMenu &&
                                link?.children?.map((item, i) => {
                                    return (
                                        <ul className='list_unstyled'>
                                            <li
                                                onClick={() => history.push(item.route)}
                                                className={`pl_5 ${item.route === history.location.pathname
                                                    ? 'active'
                                                    : ''
                                                    }`}
                                            >
                                                <span>{item.name}</span>
                                            </li>
                                        </ul>
                                    );
                                })}
                        </>
                    );
                }
                if (
                   (contextReducer.cms_type === 'pre-college' || contextReducer.cms_type === 'certificates'  || contextReducer.cms_type === 'dl-program' )  &&
                    contextReducer.cms_type !== 'skill-up' && role !== 'Contributor' &&
                    link.name === 'Applications' 
                ) {
                    return (
                        <ul className='list_unstyled'>
                            <li
                                onClick={() => (history.push(link.route),setSubmenu(false))}
                                className={
                                    (link.route === history.location.pathname) || (link.route === "/applications" && history.location.pathname.includes("dl-applicant-details")) ? 'active' : ''
                                }
                            >
                                <span>{link.name}</span>
                            </li>
                        </ul>
                    );
                }
                if (( contextReducer.cms_type === 'dl-program' )  && (link.name === 'Program') && role !== 'Contributor') {
                    return (
                         <ul className='list_unstyled'>
                             <li
                                 onClick={() => (history.push(link.route),setSubmenu(false))}
                                 className={link.route === history.location.pathname || history.location.pathname.includes('program') ? 'active' : ''}
                                
                             >
                                 <span>{link.name}</span>
                             </li>
                         </ul>
                     );
                 }
                 if (( contextReducer.cms_type === 'dl-program' )  && link.name === 'Events' && role !== 'Contributor') {
                    return (
                         <ul className='list_unstyled'>
                             <li
                                 onClick={() => (history.push(link.route),setSubmenu(false))}
                                 className={link.route === history.location.pathname || history.location.pathname.includes('event') ? 'active' : ''}
                                
                             >
                                 <span>{link.name}</span>
                             </li>
                         </ul>
                     );
                 }
                if (  role !== 'Contributor' &&
                    contextReducer.cms_type === 'certificates' &&
                     contextReducer.cms_type !== 'skill-up' &&
                     link.name === 'Certificates' 
                 ) {
                     return (
                         <ul className='list_unstyled'>
                             <li
                                 onClick={() => (history.push(link.route),setSubmenu(false))}
                                 className={
                                     link.route === history.location.pathname ? 'active' : ''
                                 }
                             >
                                 <span>{link.name}</span>
                             </li>
                         </ul>
                     );
                 }
                if (
                    link.route === '/courses' &&
                    history.location.pathname.includes('courses')
                ) {
                    return (
                        <ul className='list_unstyled'>
                            <li onClick={() => history.push(link.route)} className={'active'}>
                                <span>{link.name}</span>
                            </li>
                        </ul>
                    );
                }
                if (
                    link.route === '/events' &&
                    history.location.pathname.includes('events') &&
                    contextReducer.cms_type === 'skill-up'
                ) {
                    return (
                        <ul className='list_unstyled'>
                            <li onClick={() => history.push(link.route)} className={'active'}>
                                <span>{link.name}</span>
                            </li>
                        </ul>
                    );
                }
                if (
                    link.route === '/free-class' &&
                    history.location.pathname.includes('free-class') &&
                    contextReducer.cms_type === 'skill-up'
                ) {
                    return (
                        <ul className='list_unstyled'>
                            <li onClick={() => history.push(link.route)} className={'active'}>
                                <span>{link.name}</span>
                            </li>
                        </ul>
                    );
                } else {
                    // if (contextReducer.cms_type !== 'skill-up' && (link.name === 'users' || link.name === 'Courses' || link.name === 'Skills')) {
                    //     return <ul className="list_unstyled">
                    //         <li onClick={() => history.push(link.route)} className={link.route === history.location.pathname ? "active" : ""}><span>{link.name}</span></li>
                    //     </ul>
                    // }
                    if (
                        contextReducer.cms_type !== 'skill-up' &&
                        contextReducer.cms_type === 'career-launch' &&
                        (link.name === 'users' ||
                            link.name === 'Courses' ||
                            link.name === 'Skills')
                    ) {
                        return (
                            <ul className='list_unstyled'>
                                <li
                                    onClick={() => history.push(link.route)}
                                    className={
                                        link.route === history.location.pathname ? 'active' : ''
                                    }
                                >
                                    <span>{link.name}</span>
                                </li>
                            </ul>
                        );
                    }
                    if (
                        contextReducer.cms_type !== 'career-launch' &&
                        role !== 'Contributor' &&
                        ( contextReducer.cms_type === 'pre-college' || contextReducer.cms_type === 'certificates' || contextReducer.cms_type === 'dl-program' ) &&
                        (link.name === 'users' || 
                            link.name === 'Courses' ||
                            link.name === 'Certificate courses' ||
                            link.name === 'Skills' ||
                            link.name === 'Contributors' || 
                            link.name === 'applicants'
                        )
                    ) {
                        return (
                            <ul className='list_unstyled'>
                                <li
                                    onClick={() => (history.push(link.route), setSubmenu(false))}
                                    className={
                                        link.route === history.location.pathname ? 'active' : ''
                                    }
                                >
                                    <span>{link.name}</span>
                                </li>
                            </ul>
                        );
                    }

                    // if (role !== 'Contributor' && contextReducer.cms_type === 'pre-college' && (link.name === 'Add Admin/Contributor')) {
                    //     return <ul className="list_unstyled">
                    //         <li onClick={() => history.push(link.route)} className={link.route === history.location.pathname ? "active" : ""}><span>{link.name}</span></li>
                    //     </ul>
                    // }
                    if (
                        role === 'Contributor' &&
                    (contextReducer.cms_type === 'certificates' || contextReducer.cms_type === 'dl-program' ) &&
                        (link.name === 'users' || link.name === 'Courses')
                    ) {
                        return (
                            <ul className='list_unstyled'>
                                <li
                                    onClick={() => history.push(link.route)}
                                    className={
                                        link.route === history.location.pathname ? 'active' : ''
                                    }
                                >
                                    <span>{link.name}</span>
                                </li>
                            </ul>
                        );
                    } else if (contextReducer.cms_type === 'skill-up' && role !== 'Contributor') {
                        return (
                            <ul className='list_unstyled'>
                                <li
                                    onClick={() => (history.push(link.route),setSubmenu(false))}
                                    className={
                                        link.route === history.location.pathname ? 'active' : ''
                                    }
                                >
                                    <span>{link.name}</span>
                                </li>
                            </ul>
                        );
                    }

                if( role === 'Contributor'){
                    if(contextReducer.cms_type === 'skill-up' &&  link.name === 'users'){
                        return (
                            <ul className='list_unstyled'>
                                <li
                                    onClick={() => (history.push(link.route),setSubmenu(false))}
                                    className={
                                        link.route === history.location.pathname ? 'active' : ''
                                    }
                                >
                                    <span>{link.name}</span>
                                </li>
                            </ul>
                        );
                    }else if(contextReducer.cms_type === 'pre-college' &&  link.name === 'users'){
                        return (
                            <ul className='list_unstyled'>
                                <li
                                    onClick={() => (history.push(link.route),setSubmenu(false))}
                                    className={
                                        link.route === history.location.pathname ? 'active' : ''
                                    }
                                >
                                    <span>{link.name}</span>
                                </li>
                            </ul>
                        );
                    }
                }
                    // else if (contextReducer.cms_type === 'pre-college' && (link.name === 'Add Admin/Contributor')) {
                    //     return <ul className="list_unstyled">
                    //         <li onClick={() => history.push(link.route)} className={link.route === history.location.pathname ? "active" : ""}><span>{link.name}</span></li>
                    //     </ul>
                    // }
                }
                // if (
                //     contextReducer.cms_type === 'certificates' &&
                //     link?.children.length > 0
                // ) {
                //     let check =
                //         link?.children?.filter(
                //             (list) => list?.route === window?.location?.pathname
                //         ).length > 0;
                //     return (
                //         <>
                //             <ul className='list_unstyled'>
                //                 <li
                //                     onClick={() => handleClickReport(link, check)}
                //                     className={
                //                         check &&
                //                         'active d_flex align_items_center justify_content_between'
                //                     }
                //                 >
                //                     <span className='d_block fullWidth '>
                //                         {link.name}
                //                         <span className='d_block fullWidth justify_content_end'>
                //                             <img
                //                                 src={subMenu ? up_arrow : down_arrow}
                //                                 alt='Group icon'
                //                                 height='12'
                //                             />
                //                         </span>
                //                     </span>
                //                 </li>
                //             </ul>
                //             {check &&
                //                 subMenu &&
                //                 link?.children?.map((item, i) => {
                //                     return (
                //                         <ul className='list_unstyled'>
                //                             <li
                //                                 onClick={() => history.push(item.route)}
                //                                 className={`pl_5 ${item.route === history.location.pathname
                //                                     ? 'active'
                //                                     : ''
                //                                     }`}
                //                             >
                //                                 <span>{item.name}</span>
                //                             </li>
                //                         </ul>
                //                     );
                //                 })}
                //         </>
                //     );
                // }
            })}
        </div>
    );
};

export default Sidebar;
